import React from "react";

const Table = ({
  tableHeading,
  tableData,
  headingClass,
  rowClass,
  lastElementRef,
}) => {
  return (
    <div className="border rounded-2xl max-[1350px]:overflow-x-auto overflow-hidden max-h-[calc(100vh-250px)] overflow-y-auto custom-scrollbar">
      <table className="w-full rounded-2xl">
        <thead>
          <tr className=" w-full text-base font-semibold border-b bg-darkgray sticky top-0 z-10">
            {tableHeading?.map((e, index) => {
              return (
                <th key={index} className={`${headingClass} py-5`}>
                  {e}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {tableData?.map((e, index) => {
            return (
              <tr
                ref={lastElementRef}
                key={index}
                className="text-base font-normal border-t bg-white"
              >
                {Object.values(e).map((val, i) => {
                  if (index === tableData.length - 1) {
                    return (
                      <td key={i} className={`${rowClass} py-4 `}>
                        {val}
                      </td>
                    );
                  } else {
                    return (
                      <td key={i} className={`${rowClass} py-4`}>
                        {val}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
